import { CButtonClassname, EButtonColor, HeroSection, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { NextObStepLink } from '@web_opxp/features';
import { useTranslation } from '@web_opxp/language';
import * as React from 'react';

export interface IHeroSectionViewProps {
  onTopButtonHandler: React.MouseEventHandler<HTMLAnchorElement>;
}

export const HeroSectionView: React.FC<IHeroSectionViewProps> = ({ onTopButtonHandler }) => {
  const { t } = useTranslation();
  return (
    <HeroSection lottie="brain">
      <SectionTitle>{t('Welcome.Hero.Title')}</SectionTitle>
      <SectionSubtitle>{t('Welcome.Hero.Intro')}</SectionSubtitle>
      <NextObStepLink className={`${CButtonClassname} ${EButtonColor.white}`} onClick={onTopButtonHandler}>
        {t('Welcome.Hero.Action')}
      </NextObStepLink>
    </HeroSection>
  );
};

export default HeroSectionView;
